// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YkxQ","col":"styles_col__2_JnD"};